const convertSnakeCaseToSpaces = (str) =>
  str
    .replace(/_/g, ' ')
    .toLowerCase()
    .split(' ')
    .map((e) => e[0].toUpperCase() + e.slice(1))
    .join(' ');

export default convertSnakeCaseToSpaces;
